import React from 'react';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/en-US';
import '@formatjs/intl-relativetimeformat/locale-data/en-GB';
import '@formatjs/intl-relativetimeformat/locale-data/fr';
import '@formatjs/intl-relativetimeformat/locale-data/de';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import locales from 'locales';
import enUS from 'locales/en-US';
import enGB from 'locales/en-GB';
import frFR from 'locales/fr-FR';
import deDE from 'locales/de-DE';
import glbGlb from 'locales/glb-glb';

const localeMessagesMap = {
  'en-US': enUS,
  'fr-FR': frFR,
  'de-DE': deDE,
  'en-GB': enGB,
  'glb-glb': glbGlb,
};

export const errorHandler = err => {
  if (err.code === 'MISSING_TRANSLATION') {
    // this warning became too noisy, enable it back when needed
    // console.warn('Missing translation', err.message);
    return;
  }
  throw err;
};

const LocalizationProvider = ({ children, settings, excludeAntdConfigProvider }) => {
  const { locale } = settings;
  const localeMessages = localeMessagesMap[locale] || enUS;

  const currentLocale = locales[locale];
  const isGlobal = locale === 'glb-glb';
  if (excludeAntdConfigProvider) {
    return (
      <IntlProvider
        locale={isGlobal ? 'en' : currentLocale.locale}
        messages={isGlobal ? glbGlb : localeMessages}
        onError={errorHandler}
      >
        {children}
      </IntlProvider>
    );
  }

  return (
    <ConfigProvider locale={currentLocale.antdData}>
      <IntlProvider
        locale={isGlobal ? 'en' : currentLocale.locale}
        messages={isGlobal ? glbGlb : localeMessages}
        onError={errorHandler}
      >
        {children}
      </IntlProvider>
    </ConfigProvider>
  );
};

export default connect(({ settings }) => ({ settings }))(LocalizationProvider);
